import React, { useState, useEffect } from 'react';
import { authService } from '../services/api';
import '../styles/Dashboard.css';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [senhaError, setSenhaError] = useState('');
  const [senhaSuccess, setSenhaSuccess] = useState('');
  const [senhaLoading, setSenhaLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setSenhaAtual('');
      setNovaSenha('');
      setConfirmarSenha('');
      setSenhaError('');
      setSenhaSuccess('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const close = () => {
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSenhaError('');
    setSenhaSuccess('');
    if (!senhaAtual || !novaSenha || !confirmarSenha) {
      setSenhaError('Preencha todos os campos.');
      return;
    }
    if (novaSenha.length < 6) {
      setSenhaError('A nova senha deve ter no mínimo 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setSenhaError('A confirmação não coincide com a nova senha.');
      return;
    }
    try {
      setSenhaLoading(true);
      await authService.changePassword(senhaAtual, novaSenha);
      setSenhaSuccess('Senha alterada com sucesso.');
      setSenhaAtual('');
      setNovaSenha('');
      setConfirmarSenha('');
      setTimeout(() => {
        onClose();
      }, 1200);
    } catch (error) {
      const data = error.response?.data;
      const msg =
        data?.error ||
        data?.errors?.[0]?.msg ||
        'Erro ao alterar senha.';
      setSenhaError(msg);
    } finally {
      setSenhaLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={close}>
      <div
        className="modal-content modal-content-anuncio"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="change-password-title"
        aria-modal="true"
      >
        <div className="modal-header">
          <h2 id="change-password-title">Alterar senha</h2>
          <span className="close-modal" onClick={close} role="button" tabIndex={0}>×</span>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            {senhaError && <p className="modal-error">{senhaError}</p>}
            {senhaSuccess && <p className="modal-success">{senhaSuccess}</p>}
            <div className="form-group">
              <label htmlFor="senha-atual-nav">Senha atual</label>
              <input
                id="senha-atual-nav"
                type="password"
                autoComplete="current-password"
                value={senhaAtual}
                onChange={(e) => setSenhaAtual(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="senha-nova-nav">Nova senha</label>
              <input
                id="senha-nova-nav"
                type="password"
                autoComplete="new-password"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="Mínimo 6 caracteres"
              />
            </div>
            <div className="form-group">
              <label htmlFor="senha-confirmar-nav">Confirmar nova senha</label>
              <input
                id="senha-confirmar-nav"
                type="password"
                autoComplete="new-password"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
              />
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={close}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={senhaLoading}>
                {senhaLoading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
